import React from "react";

const EmailTemplateSelect = ({
  templates,
  value,
  setFieldValue,
  name = "emailTemplateId",
}) => {
  return (
    <div className='mb-4'>
      <label className='block mb-1 font-medium'>Email Template</label>
      <div className='relative flex items-center rounded-lg border border-gray-300  dark:bg-black dark:text-white bg-white  transition-colors duration-300 p-1'>
        <select
          name={name}
          value={value}
          onChange={(e) => setFieldValue(name, e.target.value)}
          className='flex-1 bg-transparent border-none outline-none text-gray-800 placeholder-gray-400 dark:placeholder-gray-500 px-2 bg-white dark:bg-black dark:text-white transition-colors duration-300'
        >
          <option value=''>Select Template</option>
          {templates?.map((template) => (
            <option
              className='bg-white  dark:bg-black dark:text-white h-20 overflow-y-scroll'
              key={template._id}
              value={template._id}
            >
              {template.title}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default EmailTemplateSelect;
